import {formatLocalDate} from '../../utils';
import moment from 'moment/min/moment-with-locales';

const reducer = (state = {news: [] }, action) => {


    switch (action.type) {
        case 'SET_BR_NEWS':
			const filteredNews = action.news.filter((newElement) => {
				if(newElement && newElement.news_text) {
					if(newElement.start_time_dt !== null && newElement.end !== null) {
						const now = new Date();
						const startDateUTC = formatLocalDate(newElement.start_time_dt);
						const endDateUTC = formatLocalDate(newElement.expiration_time_dt);
						const isBetween = moment(now).isBetween(startDateUTC,endDateUTC , 'seconds', "[]");

						if(isBetween) {
							return newElement.news_text.length > 0
						} 

						return false;
					}
					return newElement.news_text.length > 0
				} 
				return false;
			});
			return {...state, news: filteredNews }
		default: // need this for default case
      		return state ;
    }
}

export default reducer;